module.exports = __webpack_public_path__ + "img/G1.16d2e371.png";